import { QueryClient } from '@tanstack/react-query';
import type { QueryProviderOptions } from './QueryProvider';

/**
 * Crea un QueryClient con la configuración por defecto
 * Útil cuando ya existe un QueryClientProvider en la app
 */
export function createTableQueryClient(options: QueryProviderOptions = {}) {
  const {
    staleTime = 1000 * 60 * 5,
    gcTime = 1000 * 60 * 30,
    retry = 3,
    refetchOnWindowFocus = true,
  } = options;

  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime,
        gcTime,
        retry,
        refetchOnWindowFocus,
      },
    },
  });
}
